import LandingHeader from "../components/layout/landingHeader";
import HeroSection from "./sections/heroSection";
import ProductsSection from "./sections/productsSection";
import SecureArchitectureSection from "./sections/secureArchitectureSection";
import WhatMakesRyseDifferentSection from "./sections/whatMakesRyseDifferentSection";
import LandingFooter from "../components/layout/landingFooter";
import ArchitectureSection from "./sections/architectureSection";

export default function Home() {
  return (
    <div>
      <LandingHeader />
 
      <HeroSection />
      <ArchitectureSection />
      <SecureArchitectureSection />
      <ProductsSection />
      <WhatMakesRyseDifferentSection />
      <LandingFooter />
    </div>
  );
}
